import "../styles/home/Section2.css";

const Section2Partner = () => {
  return (
    <section
      className="htmlblock"
      style={{ backgroundColor: "white", minHeight: "0px" }}
    >
      <div className="container">
        <div className="row">
          <div className="col-md-5">
            <h2 style={{ margin: "0", color: "black" }}>
WHY PARTNER WITH COLLISION ?            </h2>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section2Partner;
